/* eslint-disable */
export default function () {
  document.addEventListener("DOMContentLoaded", function () {
    let API_TRIGGER_GOAL = `${window.location.origin}/aha-service/analytics/TriggerGoal`;
    let API_TRACK_EVENT = `${window.location.origin}/aha-service/analytics/trackevent`;
    let API_EXTERNAL_LINK = `${window.location.origin}/aha-service/analytics/TrackPageVisitExternalLinks/`;
    // D A T A  T R A C K I N G  A T T R I B U T E
    let trackingEls = document.querySelectorAll("[data-tracking]");
    // L O O P
    Array.prototype.forEach.call(trackingEls, (el) => {
      // CLICK HANDLER
      el.addEventListener("click", (e) => {
        if (e.currentTarget.getAttribute("data-tracking") === "") {
          return;
        }
        if (e.currentTarget.tagName === "A") {
          e.preventDefault();
          var _link = e.currentTarget.getAttribute("href");
          var _target = e.currentTarget.getAttribute("target");
          // get current target that has class twoClick and set it to a variable to use later
          var _twoClick = e.currentTarget.classList.contains("twoClick");
          // get the link in the modal that has the text that says "proceed" and set it to a variable to use later
          var _proceedLink = document.querySelector(".proceed");
        }
        let data = el.getAttribute("data-tracking");
        // Convert single quote to double quote, JSON format specific
        data = data.replace(/'/g, '"');
        const obj = JSON.parse(data);
        // Destructuring assignments
        const { goalId, ...pageEvent } = obj;
        let goalObj = { goalId: goalId };
        let trackEventObj = pageEvent;
        if (
          Object.keys(goalObj).length !== 0 &&
          goalObj.constructor === Object
        ) {
          postData(API_TRIGGER_GOAL, goalObj);
        }
        if (
          Object.keys(trackEventObj).length !== 0 &&
          trackEventObj.constructor === Object
        ) {
          postData(API_TRACK_EVENT, trackEventObj);
        }
        if (_twoClick) {
          _proceedLink.addEventListener("click", function () {
            if (_link !== "#") {
              setTimeout(function () {
                window.open(_link, _target);
              }, 250);
            }
          });
        }
        // commenting out to stop opening new tab and letting the link work as normal
        if (e.currentTarget.tagName === "A") {
          if (e.currentTarget.getAttribute("href") !== "#") {
            setTimeout(function () {
              // if target is null, open in same window else open in _target
              if (_target === null) {
                window.location.href = _link;
              } else {
                window.open(_link, _target);
              }
            }, 250);
          }
        }
      });
      //  handleExternalTrackingClick(e, API_EXTERNAL_LINK)
    });
    // E N D  L O O P
    /* eslint-disable-next-line */
    //data-external-tracking attribute globally, implemented on FE - Bharath and BE - Nicky - PHD only
    let dataTrackingEls = document.querySelectorAll("[data-external-tracking]");
    // Loop over each element with data-external-tracking
    Array.prototype.forEach.call(dataTrackingEls, (el) => {
      // Add click event listener
      el.addEventListener("click", (e) => {
        // Ensure e.currentTarget is not null before accessing properties
        if (
          !e.currentTarget ||
          e.currentTarget.getAttribute("data-external-tracking") === ""
        ) {
          return;
        }
        // Check that e.currentTarget exists before using tagName
        if (e.currentTarget && e.currentTarget.tagName === "A") {
          e.preventDefault();
          var _link = e.currentTarget.getAttribute("href");
          var _target = e.currentTarget.getAttribute("target");
        }
        // Get and parse the data-external-tracking attribute
        let dataTrackingExternal = e.currentTarget.getAttribute(
          "data-external-tracking",
        );
        if (!dataTrackingExternal) {
          console.error("data-external-tracking attribute is missing");
          return;
        }
        try {
          // Replace single quotes with double quotes to parse the JSON
          dataTrackingExternal = dataTrackingExternal.replace(/'/g, '"');
          const objTracking = JSON.parse(dataTrackingExternal);
          // Extract itemId and remove curly braces
          let itemId = objTracking.itemId;
          if (!itemId) {
            console.error("itemId is missing in data-external-tracking JSON");
            return;
          }
          itemId = itemId.replace(/{|}/g, "");
          // Create globalItem and send it in API call
          let globalItem = { itemId: itemId };
          if (Object.keys(globalItem).length !== 0) {
            postData(API_EXTERNAL_LINK, globalItem);
          }
          if (e.currentTarget.tagName === "A") {
            if (e.currentTarget.getAttribute("href") !== "#") {
              setTimeout(function () {
                // if target is null, open in same window else open in _target
                if (_target === null) {
                  window.location.href = _link;
                } else {
                  window.open(_link, _target);
                }
              }, 250);
            }
          }
        } catch (error) {
          console.error("Error parsing data-external-tracking JSON:", error);
        }
      });
    });
    // E N D  L O O P DATA EXTERNAL TRACKING
    // P O S T
    function postData(api, dataObj) {
      /* eslint-disable-next-line */
      fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataObj),
      })
        .then((response) => {
          // if there is a response from the server
          if (response) {
            return response.json();
          }
        })
        .then((result) => {
          if (result) {
            // log response
            // console.log('RESPONSE', result);
          }
        })
        .catch((error) => {
          if (error.constructor === Object) {
            /* eslint-disable-next-line */
            console.error("ERROR:", error);
          }
        })
        .finally(() => {
          // console.log('Promise done');
        });
    }
  });
}
import axios from "axios";
import Cookies from "js-cookie";

function postData(api, dataObj) {
  /* eslint-disable-next-line */
  fetch(api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataObj),
  })
    .then((response) => {
      // if there is a response from the server
      if (response) {
        return response.json();
      }
    })
    .then((result) => {
      if (result) {
        // log response
        // console.log('RESPONSE', result);
      }
    })
    .catch((error) => {
      if (error.constructor === Object) {
        /* eslint-disable-next-line */
        console.error("ERROR:", error);
      }
    })
    .finally(() => {
      // console.log('Promise done');
    });
}

// Function to add event listeners to elements with data-external-tracking
let API_EXTERNAL_LINK = `${window.location.origin}/aha-service/analytics/TrackPageVisitExternalLinks/`;
function attachEventListeners(dataTrackingEls) {
  Array.prototype.forEach.call(dataTrackingEls, (el) => {
    // Check if the event listener is already attached
    if (!el.dataset.trackingInitialized) {
      el.dataset.trackingInitialized = true; // Mark as initialized
      el.addEventListener("click", (e) => {
        // Ensure e.currentTarget is not null before accessing properties
        if (
          !e.currentTarget ||
          e.currentTarget.getAttribute("data-external-tracking") === ""
        ) {
          return;
        }
        // Check that e.currentTarget exists before using tagName
        if (e.currentTarget && e.currentTarget.tagName === "A") {
          e.preventDefault();
          var _link = e.currentTarget.getAttribute("href");
          var _target = e.currentTarget.getAttribute("target");
        }
        // Get and parse the data-external-tracking attribute
        let dataTrackingExternal = e.currentTarget.getAttribute(
          "data-external-tracking",
        );
        if (!dataTrackingExternal) {
          console.error("data-external-tracking attribute is missing");
          return;
        }
        try {
          // Replace single quotes with double quotes to parse the JSON
          dataTrackingExternal = dataTrackingExternal.replace(/'/g, '"');
          const objTracking = JSON.parse(dataTrackingExternal);

          // Extract itemId and remove curly braces
          let itemId = objTracking.itemId || objTracking.itemid;
          if (!itemId) {
            console.error("itemId is missing in data-external-tracking JSON");
            return;
          }
          itemId = itemId.replace(/{|}/g, "");

          // Create globalItem and send it in API call
          let globalItem = { itemId: itemId };
          if (Object.keys(globalItem).length !== 0) {
            postData(API_EXTERNAL_LINK, globalItem);
          }
          if (e.currentTarget.tagName === "A") {
            if (e.currentTarget.getAttribute("href") !== "#") {
              setTimeout(function () {
                // if target is null, open in same window else open in _target
                if (_target === null) {
                  window.location.href = _link;
                } else {
                  window.open(_link, _target);
                }
              }, 250);
            }
          }
        } catch (error) {
          console.error("Error parsing data-external-tracking JSON:", error);
        }
      });
    }
  });
}

// Initialize MutationObserver
const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      // Query newly added elements
      let newElements = document.querySelectorAll("[data-external-tracking]");
      attachEventListeners(newElements);
    }
  }
});

// Start observing the document body for added nodes
observer.observe(document.body, {
  childList: true, // Look for added/removed nodes
  subtree: true, // Monitor all descendants
});
// Run the function for any elements already present on the page
let existingElements = document.querySelectorAll("[data-external-tracking]");
if (existingElements.length > 0) {
  attachEventListeners(existingElements);
}
// Expose it globally
function handleAhaModalClose() {
  var modalVideo = document.getElementById("communityEmbedVideo");
  if (modalVideo) {
    modalVideo.src = "";
  }
}
function showVideoModal(e) {
  var videoid = e.currentTarget.getAttribute("videoid");
  var videotitle = e.currentTarget.getAttribute("videotitle");
  var videotypelink = e.currentTarget.getAttribute("videotypelink");
  var videofullcontentlink = e.currentTarget.getAttribute(
    "videofullcontentlink",
  );
  var videoteaser = e.currentTarget.getAttribute("videoteaser");
  var id = e.currentTarget.getAttribute("id");
  var videocategoryid = e.currentTarget.getAttribute("videoCategoryId");
  window.ahavm.$root.$emit("bv::show::modal", "communitiesVideoModal");
  var modalCategoryId = document.getElementById("videoCategoryId");
  modalCategoryId.Value = videocategoryid;
  var modalVideoItemId = document.getElementById("videoItemId");
  modalVideoItemId.Value = id;
  var modalVideo = document.getElementById("communityEmbedVideo");
  modalVideo.src = videotypelink.replace("{id}", videoid);
  var modalTitle = document.getElementById("modalTitle");
  modalTitle.innerText = videotitle;
  var modalTeaser = document.getElementById("modalTeaser");
  modalTeaser.innerText = videoteaser;
  var fullLink = document.getElementById("aFullContentLink");
  fullLink.href = videofullcontentlink + "?id=" + id;
  var newUrl = new URL(window.location);
  newUrl.searchParams.set("videoid", id);
  window.history.replaceState(null, "", newUrl);
  getVideoDetails(id, videocategoryid);
  if (videofullcontentlink.includes("$$CS$$")) {
    var link = videofullcontentlink.split("$$CS$$");
    fullLink.href = link[0];
    fullLink.target = link[1];
  }
}
window.handleAhaModalClose = handleAhaModalClose;
window.showVideoModal = showVideoModal;

function getVideoDetails(videoid, videocategoryid) {
  const videoDetails = {
    videoId: videoid,
    categoryId: videocategoryid,
  };
  var uri = `${window.location.origin}/aha-service/PHDApi/IsVideoSaved`;
  axios
    .post(uri, videoDetails)
    .then((res) => {
      if (res.data === null) {
        return;
      }
      var isSaved = res.data;
      window.dispatchEvent(
        new CustomEvent("globalFunctionTriggered", {
          detail: { data: res.data },
        }),
      );
    })
    .catch((err) => {
      console.log(err);
    });
}

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

const videoID = getQueryParam("videoid");
const hostname = window.location.hostname;

let baseDomain;

if (hostname.includes("d1-cd-professional.sc.heart.org")) {
  baseDomain = "https://d1-cd-professional.sc.heart.org"; // Staging
} else if (hostname.includes("u1-cd-professional.sc.heart.org")) {
  baseDomain = "https://u1-cd-professional.sc.heart.org"; // UAT
} else if (hostname.includes("professional.heart.org")) {
  baseDomain = "https://professional.heart.org"; // Production
} else {
  baseDomain = "http://localhost:3000"; // Development
}

if (videoID) {
  window.onload = function () {
    const signupUri = {
      base: `${baseDomain}/aha-service/PHDApi/LookUpVideoId?videoid=`,
      default: "",
      upgrade: "",
    };
    axios
      .get(`${signupUri.base}${videoID}`)
      .then((res) => {
        if (res.data === null) {
          window.ahavm.$root.$emit("bv::show::modal", "videoNotFoundModal");
          return;
        }
        const videoDetails = {
          id: videoID,
          typeLink: res.data.videotypelink,
          title: res.data.videotitle,
          teaser: res.data.videoteaser,
          fullContentLink: res.data.videofullcontentlink,
        };
        // Populate modal elements
        const modalVideo = document.getElementById("communityEmbedVideo");
        if (modalVideo) {
          modalVideo.src = videoDetails.typeLink.replace(
            "{id}",
            videoDetails.id,
          );
        }
        const modalTitle = document.getElementById("modalTitle");
        if (modalTitle) {
          modalTitle.innerText = videoDetails.title;
        }
        const modalTeaser = document.getElementById("modalTeaser");
        if (modalTeaser) {
          modalTeaser.innerText = videoDetails.teaser;
        }
        const fullLink = document.getElementById("aFullContentLink");
        if (fullLink) {
          fullLink.href = videoDetails.fullContentLink.replace(
            "{id}",
            videoDetails.id,
          );

          // Adjust target if $$CS$$ is included
          if (videoDetails.fullContentLink.includes("$$CS$$")) {
            const link = videoDetails.fullContentLink.split("$$CS$$");
            fullLink.href = link[0];
            fullLink.target = link[1];
          }
        }
        // Show the modal
        window.ahavm.$root.$emit("bv::show::modal", "communitiesVideoModal");
      })
      .catch((err) => {
        console.log(err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/utils/analytics-campaign-tracker.js